var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.54932,
    y: 20.1772,
    width: 17.7074,
    height: 11.7006,
    rx: 1,
    transform: "rotate(-45 3.54932 20.1772)",
    fill: "#B6EF12"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5.80825,
    height: 11.7006,
    rx: 1,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 20.1772 3.54932)",
    fill: "#FF9838"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.76141 27.7897L3.57609 20.8126C3.56648 20.4506 4.00465 20.2632 4.25984 20.5202L11.4212 27.7347C11.6764 27.9918 11.4858 28.4286 11.1237 28.4163L4.14767 28.1789C3.93628 28.1717 3.76703 28.0012 3.76141 27.7897Z",
    fill: "#FFE7B8",
    stroke: "#FFE7B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.61808 28.3145L3.55267 25.8662C3.55146 25.821 3.60609 25.7976 3.63803 25.8296L6.16573 28.3611C6.19777 28.3932 6.17397 28.448 6.12865 28.4464L3.66637 28.3631C3.63995 28.3622 3.61879 28.3409 3.61808 28.3145Z",
    fill: "#3D3D3D",
    stroke: "#3D3D3D",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6095 16.4867L23.5147 19.3962C23.5795 19.6046 23.5261 19.8317 23.3752 19.9894L18.7401 24.8316",
    stroke: "#B6EF12",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14307 20.3125L16.1431 12.3125",
    stroke: "#CCFA48",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7495 23.7944L19.7495 15.7944",
    stroke: "#CCFA48",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.0a79b0a5235b4e130f7ff5a56f2485b9.svg";
export { ForwardRef as ReactComponent };